module.exports = __webpack_public_path__ + "static/visionar_case_study_ar-for-interactive-product-catalogues-400x284-126bbd26cc75e4e288d34b062615e2a0.jpg";